import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  NewListingDiscountDetermineEnrollmentPayload,
  NewListingDiscountDetermineEnrollmentResponse,
} from 'models/vrbo/NewListingDiscount';
import API from 'services/API';

export const NEW_LISTING_DISCOUNT_DETERMINE_ENROLLMENT_BASE_QUERY_KEY =
  'new-listing-discount-determine-enrollment';

type ReactQueryOptions = Omit<
  UseQueryOptions<NewListingDiscountDetermineEnrollmentResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchDetermineEnrollmentArgs =
  Partial<NewListingDiscountDetermineEnrollmentPayload> & ReactQueryOptions;

const useFetchDetermineEnrollment = ({
  agencyUid,
  propertyUid,
  enabled = true,
  ...options
}: UseFetchDetermineEnrollmentArgs) => {
  return useAppQuery<NewListingDiscountDetermineEnrollmentResponse>({
    queryKey: [
      NEW_LISTING_DISCOUNT_DETERMINE_ENROLLMENT_BASE_QUERY_KEY,
      agencyUid,
      propertyUid,
    ],
    queryFn: async () => {
      if (!agencyUid || !propertyUid) {
        throw new Error('agencyUid or propertyUid is required.');
      }

      const response =
        await API.post<NewListingDiscountDetermineEnrollmentResponse>(
          '/api/internal/vrbo/new-listing-discount/determine-enrollment',
          {
            agencyUid,
            propertyUid,
          },
        );

      return response.data;
    },
    enabled: enabled && !!agencyUid && !!propertyUid,
    staleTime: 30000,
    cacheTime: 5 * 60 * 1000,
    retry: 0,
    ...options,
  });
};

export default useFetchDetermineEnrollment;
